import { render } from "./app-header-user.vue?vue&type=template&id=3a2dc2ac&scoped=true"
import script from "./app-header-user.vue?vue&type=script&lang=js"
export * from "./app-header-user.vue?vue&type=script&lang=js"

import "./app-header-user.vue?vue&type=style&index=0&id=3a2dc2ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a2dc2ac"]])

export default __exports__